module.exports = __webpack_public_path__ + "static/media/icon-zip.5b530c0c.svg";